import { KeyValueModel } from "model";
import { EnumTpDesconto } from "model/enums/enum-tp-desconto";

export const TpDescontoMock: KeyValueModel[] = [
    new KeyValueModel(EnumTpDesconto.DescontoPercentual, "Desconto Percentual"),
    new KeyValueModel(EnumTpDesconto.DescontoValor, "Desconto por Valor"),
    new KeyValueModel(EnumTpDesconto.DescontoPercentualAntecipacaoDiaCorrido, "Desconto Percentual (Antecipação por Dia Corrido)"),
    new KeyValueModel(EnumTpDesconto.DescontoValorAntecipacaoDiaCorrido, "Desconto por Valor (Antecipação por Dia Corrido)"),
    new KeyValueModel(EnumTpDesconto.SemDesconto, "Sem Desconto"),
];